import { Observable } from "rxjs";

export class EdpTable {
    private args: any;
    public pageSize = 20;
    private endPoint: string;
    private context: string;
    private actions: Array<any> = [];
    private columns: Array<any>;
    private orderBy: Array<any>;
    private searchableColumns: string[] = [];
    private noResultMessage: any;
    private beforeRenderFunction: CallableFunction;
    private afterListUpdateFunction: CallableFunction;
    private dataSourceFunction: CallableFunction;

    public getArgs(): any|null {
        return this.args;
    }

    public setArgs(args: any): EdpTable {
        this.args = args;
        return this;
    }

    public getEndpoint(): string {
        return this.endPoint;
    }

    public setEndpoint(endpoint: string): EdpTable {
        this.endPoint = endpoint;
        return this;
    }

    public setDataSource(dataSource: CallableFunction): EdpTable {
        this.dataSourceFunction = dataSource;
        return this;
    }

    public getDataSource(args?: any): Observable<any> {
        return this.dataSourceFunction(args);
    }

    public getColumns(): Array<any> {
        return this.columns;
    }
    public setColumns(columns: Array<any>): EdpTable {
        this.columns = columns;
        return this;
    }

    public getSearchableColumns(): Array<any> {
        if (!this.searchableColumns.length) {
            this.searchableColumns = this.columns.filter(column => {
                return column.searchable;
            }).map(column => {
                return column;
            });
        }

        return this.searchableColumns;
    }

    public getOrder(): Array<any> {
        return this.orderBy;
    }

    public setOrder(orderBy: Array<any>): EdpTable {
        this.orderBy = orderBy;
        return this;
    }

    public setContext(name: string): EdpTable {
        this.context = name;
        return this;
    }

    public getContext(): string {
        return this.context;
    }

    public getPageSize(): number {
        return this.pageSize;
    }
    public setPageSize(pageSize: number): EdpTable {
        this.pageSize = pageSize;
        return this;
    }

    public getNoResultsMessage(): any|null  {
        return this.noResultMessage;
    }
    public setNoResultsMessage(messages: any): EdpTable {
        this.noResultMessage = messages;
        return this;
    }

    public beforeRender(action: CallableFunction): EdpTable {
        this.beforeRenderFunction = action;
        return this;
    }

    public afterListUpdate(action: CallableFunction): EdpTable {
        this.afterListUpdateFunction = action;
        return this;
    }

    public executeBeforeRender(collection: any): any {
        if ("undefined" !== typeof this.beforeRenderFunction) {
            return this.beforeRenderFunction(collection);
        }
        return collection;
    }

    public executeAfterListUpdateFunction(collection: any[]): any {
        if ("undefined" !== typeof this.afterListUpdateFunction) {
            return this.afterListUpdateFunction(collection);
        }
        return collection;
    }

    public getActions(): Array<any> {
        return this.actions;
    }
    public addAction(icon: string, callback: any, condition?: CallableFunction): EdpTable {
        this.actions.push({icon, callback, condition});
        return this;
    }
}
